module.exports = __webpack_public_path__ + "img/icon-stockpicker-training-done@2x.ba0088f7.png";